import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { setCountry, getCountry } from '../Services/Global';

/**
 * Custom hook to synchronize country parameter from URL with localStorage
 * 
 * - On initial load: saves country from URL to localStorage (or 'XX' if not present)
 * - On URL changes: updates localStorage if country parameter changes in URL
 * 
 * @export
 * @return {void}
 */
export function useCountrySync(): void {
  const location = useLocation();

  useEffect(() => {
    // Parse country from current URL
    const urlParams = new URLSearchParams(location.search);
    const countryFromUrl = urlParams.get('country');

    if (countryFromUrl) {
      // If country is in URL, ALWAYS update localStorage (even if it's the same)
      // This ensures localStorage is the single source of truth and always matches URL
      setCountry(countryFromUrl);
    } else {
      // If no country in URL, check if we need to set default
      const savedCountry = getCountry();
      if (!savedCountry) {
        // Only set default if localStorage is empty
        setCountry('XX');
      }
      // If country exists in localStorage but not in URL, keep localStorage value
      // (user might be on a page that doesn't require country in URL)
    }
  }, [location.search]); // Re-run when URL search params change
}

